import { useParams } from "next/navigation";
import { TextAlignment } from "@/constants/content";
import { SiteBuilderModuleTextFieldType } from "@/constants/site-builder";
import { ColorVariant, FontVariant } from "@/constants/theme";
import { createThemeColorObject } from "@/utils/theme/createThemeColorObject";
import type { ExtendedUploadedImage } from "@/types";
import type { SiteBuilderModuleTextField } from "@/types/site-builder";
import { DisplayVariant } from "../constants";
import SponsorVariant1 from "../SponsorVariant1";
import SponsorVariant2 from "../SponsorVariant2";
import { type Sponsor } from "../types";
import { getSponsorUrlData } from "../utils/getSponsorUrlData";

export interface SponsorVariantsMapperProps {
  variant: DisplayVariant;
  logoSettings: ExtendedUploadedImage;
  sponsor: Sponsor;
  disableCardUrl: boolean;
}

export default function SponsorVariantsMapper(
  props: SponsorVariantsMapperProps,
) {
  const { variant, logoSettings, sponsor, disableCardUrl } = props;
  const { sitePath } = useParams<{ sitePath: string }>();

  const { url: sponsorUrl, openInNewTab } = getSponsorUrlData(
    sponsor,
    sitePath,
  );
  const logoImage = {
    ...logoSettings,
    source: { path: sponsor.logo?.path },
  };
  const sponsorNameTextField: SiteBuilderModuleTextField = {
    type: SiteBuilderModuleTextFieldType.Text,
    alignment: TextAlignment.Center,
    fontVariant: FontVariant.Default,
    color: createThemeColorObject(ColorVariant.White),
    text: sponsor.name,
  };

  switch (variant) {
    case DisplayVariant.Variant1:
      return (
        <SponsorVariant1
          url={sponsorUrl}
          logo={logoImage}
          logoTexField={sponsorNameTextField}
          openInNewTab={openInNewTab}
          disableLink={disableCardUrl}
        />
      );
    case DisplayVariant.Variant2:
      return (
        <SponsorVariant2
          url={sponsorUrl}
          logo={logoImage}
          openInNewTab={openInNewTab}
          disableLink={disableCardUrl}
        />
      );
  }
}
